module.exports = __webpack_public_path__ + "static/media/s4.67853710.png";